export default __webpack_public_path__ + "static/media/9.08799ec3.jpg";